import { Component, OnInit, Inject } from '@angular/core';
import {DOCUMENT} from "@angular/common";
import { Router } from '@angular/router';
import { PageNotFoundReasonCode, PageNotFoundReasons } from 'projects/store/src/app/enums/page-not-found-reasons.enum';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found-component.html',
})
export class PageNotFoundComponent implements OnInit {
  caseId: string | undefined;
  attemptedUrl: string | undefined;

  constructor(@Inject(DOCUMENT) private document: Document, private router: Router) {
    let themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = 'krediya.v2-theme.css';
    }
  }

  ngOnInit(): void {
    this.caseId = history.state.caseId;
    this.attemptedUrl = history.state.attemptedUrl
  }
}
